// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OoKr","content":"styles_content__2hr5s","tableWrap":"styles_tableWrap__3llfH"};